import React, { useEffect, useState } from "react";
import PageHeading from "../../../../components/common/PageHeading";
import {
  Form,
  Input,
  Select,
  Button,
  Col,
  Row,
  Card,
  Checkbox,
  message,
} from "antd";
import PhoneNumbers from "./Components/PhoneNumbers";
import Emails from "../../../Leasing/RentalApplications/Components/Emails";
// import Addresses from '../../../'
import PaymentAddress from "./Components/PaymentAddress";
import TextArea from "antd/es/input/TextArea";
import IncludedReports from "./Components/IncludedReports";
import FormAction from "../../../../components/common/FormAction";
import AttachmentsUpload from "../../../../components/common/AttachmentsUpload";
import Notes from "../../../../components/common/Notes";
import { createNewOwner } from "./OwnerFirebase";
import { useAuthState } from "react-firebase-hooks/auth";
import {
  salutations,
  sendingPref,
  consolidateChecks,
  accountType,
} from "../../../../utils/Util";
import { useNavigate } from "react-router-dom";
import { auth, db } from "../../../../firebase";
import { collection, getDocs, query, where } from "firebase/firestore";
import OwnerAddresses from "./Components/OwnerAddresses";
const { Option } = Select;

function NewOwner() {
  const [ownerAddress, setOwnerAddress] = useState(false);
  const [send099, setSend1099] = useState(false);
  const [user, loading] = useAuthState(auth);
  const [companyName, setcompanyName] = useState("");
  const [notes, setNotes] = useState([]);
  const [isWait, setIsWait] = useState(false);

  const fetchCompanyName = async () => {
    try {
      const usersRef = collection(db, "allUsers");
      const userData = query(usersRef, where("uid", "==", user.uid));

      getDocs(userData)
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            const res = doc.data();
            setcompanyName(res.companyName);
          });
        })
        .catch((error) => {
          console.log("Error getting users: ", error);
        });
    } catch (err) {
      console.error(err);
    }
  };
  useEffect(() => {
    fetchCompanyName();
  }, [user, loading]);

  const [phoneNumbers, setPhoneNumbers] = useState([
    { id: 1, phoneNumber: "", type: "", additionalDetails: "" },
  ]);

  const [emails, setEmails] = useState([{ id: 1, email: "" }]);

  const [ownerAddresses, setOwnerAddresses] = useState([
    { id: 1, addressOne: "", addressTwo: "", city: "", state: "", country: "" },
  ]);

  const [includedReports, setIncludedReports] = useState([
    { id: 1, includedReport: "" },
  ]);
  const [files, setFiles] = useState([]);

  const navigate = useNavigate();
  const onFinish = (values) => {
    setIsWait(true);
    //   console.log("Success:", values);

    const phNumber = phoneNumbers.filter((item) => {
      return Object.keys(item).some((key) => key !== "id" && item[key] !== "");
    });
    const mails = emails.filter((item) => {
      return Object.keys(item).some((key) => key !== "id" && item[key] !== "");
    });

    const addresses = ownerAddresses.filter((item) => {
      return Object.keys(item).some((key) => key !== "id" && item[key] !== "");
    });

    const reports = includedReports.filter((item) => {
      return Object.keys(item).some((key) => key !== "id" && item[key] !== "");
    });

    const filteredNotes = notes.filter((item) => {
      return Object.keys(item).some((key) => key !== "id" && item[key] !== "");
    });

    createNewOwner(
      values,
      companyName,
      phNumber,
      mails,
      addresses,
      reports,
      filteredNotes,
      files
    ).then(() => {
      message.success("New Owner Created SuccessFully!", 2);
      navigate("/people/owners");
      setIsWait(false);
    });
  };
  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
    message.error("Please fill in all the required fields!", 2);
    setIsWait(false);
  };
  const options = [
    { value: "cartpet cleaning", label: "chimny cleaning" },
    { value: "dreanage", label: "dreanage" },
    { value: "chimny cleaning", label: "dreanage" },
  ];
  return (
    <>
      <PageHeading heading="New Owner" />
      <Form
        name="basic"
        labelCol={{ span: 7 }}
        initialValues={{ remember: true }}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        autoComplete="off"
        className="form-container"
        colon={false}
      >
        <Row>
          <Col span={24}>
            {/* Owner Information */}

            <Card title="Owner Information" bordered={false}>
              <Form.Item label="Salutation" name="salutation">
                <Select>
                  {salutations.map((item) => (
                    <Option key={item.value} value={item.value}>
                      {item.value}
                    </Option>
                  ))}
                </Select>
              </Form.Item>

              <Form.Item
                name="firstName"
                label="First Name"
                rules={[
                  {
                    required: true,
                    message: "Please input your First Name!",
                  },
                ]}
              >
                <Input />
              </Form.Item>

              <Form.Item
                name="lastName"
                label="Last Name"
                rules={[
                  {
                    required: true,
                    message: "Please input your Last Name!",
                  },
                ]}
              >
                <Input />
              </Form.Item>

              <Form.Item label="Company Name" name="companyName">
                <Input />
              </Form.Item>

              <Form.Item
                label="Use company name as display name"
                name="useCompanyNameAsDisplay"
                valuePropName="checked"
              >
                <Checkbox></Checkbox>
              </Form.Item>

              <Form.Item label="Tags" name="tags">
                <Select
                  mode="tags"
                  style={{
                    width: "100%",
                  }}
                  tokenSeparators={[","]}
                  options={options}
                />
              </Form.Item>
              <Form.Item label=" ">
                <Button type="link" style={{ padding: 0 }}>
                  Manage Tags
                </Button>
              </Form.Item>
            </Card>

            <br />

            {/* Contact */}

            <Card title="Contact" bordered={false}>
              <h4 style={{ fontSize: 13, marginBottom: 20 }}>Phone Numbers</h4>

              <PhoneNumbers
                phoneNumbers={phoneNumbers}
                setPhoneNumbers={setPhoneNumbers}
              />

              <h4 style={{ fontSize: 13, marginBottom: 20 }}>Emails</h4>

              <Emails emails={emails} setEmails={setEmails} />

              <h4 style={{ fontSize: 13, marginBottom: 20 }}>Addresses</h4>

              <OwnerAddresses
                ownerAddresses={ownerAddresses}
                setOwnerAddresses={setOwnerAddresses}
              />

              <h4 style={{ fontSize: 13, marginBottom: 20 }}>
                Payment Address
              </h4>

              <Form.Item label=" ">
                <Checkbox
                  checked={ownerAddress}
                  onClick={() => setOwnerAddress(!ownerAddress)}
                >
                  Use owner address as payment address
                </Checkbox>
              </Form.Item>

              {!ownerAddress ? <PaymentAddress type="owner" /> : <></>}
            </Card>

            <br />

            {/* Federal Tax */}

            <Card title="Federal Tax" bordered={false}>
              <Form.Item
                name="taxPayerName"
                label="Taxpayer Name"
                wrapperCol={{ span: 8 }}
                valuePropName="checked"
              >
                <Input />
              </Form.Item>
              <Form.Item
                label="Use company name as taxpayer name"
                name="useCompanyName"
                valuePropName="checked"
              >
                <Checkbox></Checkbox>
              </Form.Item>
              <Form.Item
                name="taxPayerId"
                label="Taxpayer ID"
                wrapperCol={{ span: 8 }}
                valuePropName="checked"
              >
                <Input />
              </Form.Item>

              <Form.Item
                label="Send 1099?"
                name="send099"
                wrapperCol={{ span: 8 }}
                valuePropName="checked"
              >
                {/* <Checkbox checked={send099} onClick={() => setSend1099(!send099)} /> */}
                <Checkbox onClick={() => setSend1099(!send099)}></Checkbox>
              </Form.Item>

              {send099 ? (
                <>
                  <Form.Item
                    name="receiveElectronic"
                    label="Owner consented to receive electronic 1099?"
                    wrapperCol={{ span: 8 }}
                    valuePropName="checked"
                  >
                    <Checkbox></Checkbox>
                  </Form.Item>

                  <Form.Item
                    name="sendingPreference"
                    label="1099 Sending Preference"
                    wrapperCol={{ span: 8 }}
                    valuePropName="checked"
                  >
                    <Select>
                      {sendingPref.map((item) => (
                        <Option key={item.value} value={item.value}>
                          {item.value}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                </>
              ) : (
                <></>
              )}
            </Card>

            <br />

            {/* Accounting Information*/}

            <Card title="Accounting Information" bordered={false}>
              <Form.Item
                label="Consolidate Checks"
                wrapperCol={{ span: 8 }}
                valuePropName="checked"
                name="consolidateChecks"
              >
                <Select>
                  {consolidateChecks.map((item) => (
                    <Option key={item.value} value={item.value}>
                      {item.value}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
              <Form.Item
                label="Hold Payments"
                name="holdPayments"
                valuePropName="checked"
              >
                <Checkbox></Checkbox>
              </Form.Item>
              <Form.Item
                label="Email eCheck Receipt?"
                name="emailCheckReceipt"
                valuePropName="checked"
              >
                <Checkbox></Checkbox>
              </Form.Item>
              <Form.Item
                name="defaultCheckMemo"
                label="Default Check Memo"
                wrapperCol={{ span: 8 }}
                valuePropName="checked"
              >
                <Input />
              </Form.Item>
            </Card>

            <br />

            {/* Owner Statement */}

            <Card title="Owner Statement" bordered={false}>
              <Form.Item
                name="showTransactionsDetail"
                label="Show Transactions Detail"
                wrapperCol={{ span: 8 }}
                valuePropName="checked"
              >
                <Checkbox></Checkbox>
              </Form.Item>
              <Form.Item
                name="showUnpaidBillsDetail"
                label="Show Unpaid Bills Detail"
                wrapperCol={{ span: 8 }}
                valuePropName="checked"
              >
                <Checkbox></Checkbox>
              </Form.Item>
              <Form.Item
                name="showTenantNames"
                label="Show Tenant Names"
                wrapperCol={{ span: 8 }}
                valuePropName="checked"
              >
                <Checkbox></Checkbox>
              </Form.Item>
              <Form.Item
                name="showSummary"
                label="Show Summary"
                wrapperCol={{ span: 8 }}
                valuePropName="checked"
              >
                <Checkbox></Checkbox>
              </Form.Item>
              <Form.Item
                name="seperateManagementFeeFromCashOut"
                label="Seperate Management Fee From Cash Out"
                wrapperCol={{ span: 8 }}
                valuePropName="checked"
              >
                <Checkbox></Checkbox>
              </Form.Item>
              <Form.Item name="notesForOwners" label="Notes for the Owner">
                <TextArea rows={5} />
              </Form.Item>
            </Card>

            <br />

            {/* Owner Packet */}

            <Card title="Owner Packet" bordered={false}>
              <Form.Item
                name="sendViaEmail"
                label="Send Via Email"
                wrapperCol={{ span: 8 }}
                valuePropName="checked"
              >
                <Checkbox></Checkbox>
              </Form.Item>
              <Form.Item
                name="includePaidWorkOrders"
                label="Include Paid Work Orders"
                wrapperCol={{ span: 8 }}
                valuePropName="checked"
              >
                <Checkbox></Checkbox>
              </Form.Item>
              <Form.Item
                name="includePaidWorkOrderAttachments"
                label="Include Paid Work Order Attachments"
                wrapperCol={{ span: 8 }}
                valuePropName="checked"
              >
                <Checkbox></Checkbox>
              </Form.Item>
              <Form.Item
                name="includePaidBillsAttachments"
                label="Include Paid Bills Attachments"
                wrapperCol={{ span: 8 }}
                valuePropName="checked"
              >
                <Checkbox></Checkbox>
              </Form.Item>
              <Form.Item name="glAccountMap" label="GL Account Map">
                <Select>
                  {accountType.map((item) => (
                    <Option key={item.value} value={item.value}>
                      {item.value}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
              <IncludedReports
                includedReports={includedReports}
                setIncludedReports={setIncludedReports}
              />
            </Card>

            <br />

            <Card title="Maintenance Information" bordered={false}>
              <Form.Item name="ownerSpecificNotes" label="Owner Specific Notes">
                <TextArea rows={5} />
              </Form.Item>
            </Card>

            <br />
            {companyName ? (
              <Notes
                notesForCollection="owners"
                notesForCollectionId=""
                companyName={companyName}
                notes={notes}
                setNotes={setNotes}
              />
            ) : null}
            <br />

            <AttachmentsUpload setFiles={setFiles} />
            <br />

            <Row gutter={16}>
              <Col>
                <Button type="primary" htmlType="submit" loading={isWait}>
                  {isWait ? "Please wait..." : "Save"}
                </Button>
              </Col>
              <Col>
                <Button
                  onClick={() => {
                    navigate("/people/owners");
                  }}
                >
                  Cancel
                </Button>
              </Col>
            </Row>
            <br />
          </Col>
        </Row>
      </Form>

      <div className="RightSidebar"></div>
    </>
  );
}

export default NewOwner;
